import React from 'react'
import '../../stylings/admissionNotice.css'

const AdmissionNotice = () => {
  return (
    <div className="admission-notice notice-header">
            <p>
                ADMISSION OPEN FOR THE SESSION 2025-2026. For more details contact at
                <span>wtlfoundation91@gmail.com</span>
            </p>
        </div>
  )
}

export default AdmissionNotice
